import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

export default ({ type, items, handleClick, activeLabel }) => {
  const toggleFilter = e => {
    const parent = document.querySelector('.js-dropdown-label')
    parent.classList.toggle('c-dropdown--active')
  }
  let defaultClass = 'c-dropdown__item'
  let allClass = 'c-dropdown__item c-dropdown__item--active'
  if (activeLabel.name !== '') {
    allClass = 'c-dropdown__item'
  }
  return (
    <section className="c-dropdown js-dropdown-label">
      <div className="c-dropdown__title" onClick={toggleFilter}>
        <span className="js-dropdown-title">{type}</span>
        <svg className="c-dropdown__icon">
          <use xlinkHref="#up-arrow" />
        </svg>
      </div>
      <div className="c-dropdown__container">
        <div className={allClass} onClick={handleClick} data-id="">
          Alles
        </div>
        {items.map((item, key) => {
          if (activeLabel.name === item.name) {
            defaultClass = 'c-dropdown__item c-dropdown__item--active'
          } else {
            defaultClass = 'c-dropdown__item'
          }
          return (
            <div className={defaultClass} onClick={handleClick} data-name={item.name} data-id={item.id}>
              {item.name}
            </div>
          )
        })}
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/js/blog/Label.js